import { useMutation } from '@apollo/client';
import { Card } from 'antd';
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { ROUTES } from '../../../common/constants';
import { formatPhoneNumberWithoutMask } from '../../../common/utils';
import GoBackButton from '../../../components/GoBackButton';
import Portal from '../../../components/Portal';
import UserForm from '../components/UserForm';
import { CREATE_USER } from '../graphql/Mutations';

function UserCreate(props) {
  const { history = null, location = null } = props;
  const [submitLoading, setSubmitLoading] = useState(false);
  const [createUserMutate] = useMutation(CREATE_USER, {
    onError: () => {
      setSubmitLoading(false);
    }
  });

  useEffect(() => {
    return () => {
      if (history?.action === 'POP') {
        history?.push(history?.pathname, {
          ...location?.state
        });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleSubmit = async (formValues) => {
    setSubmitLoading(true);
    const locations = [];
    if (
      formValues?.addressLine1 ||
      formValues?.city ||
      formValues?.state ||
      formValues?.country ||
      formValues?.zipCode
    ) {
      locations?.push({
        addressLine1: formValues?.addressLine1 || null,
        city: formValues?.city || null,
        state: formValues?.state || null,
        country: formValues?.country || null,
        zipCode: formValues?.zipCode || null
      });
    }

    const newFormValues = {
      ...formValues,
      createdFrom: 'WEB_PORTAL',
      phoneNo: formatPhoneNumberWithoutMask(formValues?.phoneNo),
      locations
    };
    delete newFormValues?.addressLine1;
    delete newFormValues?.city;
    delete newFormValues?.state;
    delete newFormValues?.country;
    delete newFormValues?.zipCode;

    const variables = newFormValues;

    try {
      const response = await createUserMutate({
        variables: { data: { ...variables } }
      });
      if (response?.data?.createUser) {
        history?.push(ROUTES?.USERS, { ...location?.state });
      }
    } catch (error) {
      setSubmitLoading(false);
      return error;
    }
  };

  const initialValues = {
    country: 'USA'
  };

  return (
    <Card className="full-height-card card-body-padding">
      <Portal portalId="header-left-content">
        <div className="d-flex align-center">
          <GoBackButton customLink={ROUTES?.USERS} />
          <span className="portal-header">Add User</span>
        </div>
      </Portal>
      <UserForm
        userData={initialValues}
        handleSubmit={handleSubmit}
        isSubmit={submitLoading}
      />
    </Card>
  );
}

export default withRouter(UserCreate);
